import React from "react";
import {
  Ambulance,
  Apple,
  ArrowUpRight,
  Brain,
  Dumbbell,
  Eye,
  FlaskConical,
  HeartPulse,
  Hospital,
  Pill,
  ScanLine,
  Smile,
  Stethoscope,
} from "lucide-react";
import { PARTNER_CATEGORIES, PORTAL_LINKS } from "../../lib/site-data";

const ICONS = {
  Ambulance,
  Apple,
  Brain,
  Dumbbell,
  Eye,
  FlaskConical,
  HeartPulse,
  Hospital,
  Pill,
  ScanLine,
  Smile,
  Stethoscope,
};

export default function PartnerNetwork() {
  return (
    <section
      id="network"
      data-testid="partner-network"
      className="relative bg-cream py-24 lg:py-32"
    >
      <div className="container-x">
        <div className="max-w-3xl mb-14 lg:mb-20">
          <p className="text-[12.5px] font-semibold uppercase tracking-[0.18em] text-forest">
            Our partner network
          </p>
          <h2 className="mt-4 font-display text-ink text-[36px] sm:text-[44px] lg:text-[56px] font-extrabold leading-[1.05] tracking-tight text-balance">
            One platform, every kind of provider your patients need.
          </h2>
          <p className="mt-5 text-[17px] text-ink/65 max-w-2xl leading-relaxed">
            Doctors on TeleMedCare can refer to vetted partners across twelve provider categories — from pharmacies and labs to specialists, home-care nurses, physiotherapists and ambulance services. One continuous record, no lost handoffs.
          </p>
        </div>

        <ul
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-5"
          aria-label="Partner provider categories"
        >
          {PARTNER_CATEGORIES.map((c) => {
            const Icon = ICONS[c.icon];
            return (
              <li
                key={c.id}
                data-testid={`partner-category-${c.id}`}
                className="group relative bg-white rounded-3xl border border-ink/10 p-6 transition-all hover:-translate-y-0.5 hover:border-forest/30 hover:shadow-[0_18px_40px_rgba(14,35,51,0.08)]"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-forest/10 text-forest">
                  {Icon ? <Icon className="h-5 w-5" strokeWidth={1.75} /> : null}
                </div>
                <p className="mt-5 font-display text-[18px] font-bold text-ink leading-tight tracking-tight">
                  {c.label}
                </p>
                <p className="mt-2 text-[14px] text-ink/65 leading-relaxed">
                  {c.blurb}
                </p>
              </li>
            );
          })}
        </ul>

        <div className="mt-14 lg:mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
          <a
            href={PORTAL_LINKS.partnerApply}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-network-cta"
            className="group inline-flex items-center gap-1.5 rounded-full bg-forest hover:bg-forest/90 text-cream px-6 py-3 text-[15px] font-semibold shadow-md hover:-translate-y-0.5 transition-all"
          >
            Apply as a partner
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <p className="text-[14px] text-ink/55 max-w-md leading-relaxed">
            Are you a clinician, clinic or service provider? Join in minutes — our team reviews applications within 1-2 business days.
          </p>
        </div>
      </div>
    </section>
  );
}
